import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Helmet } from 'react-helmet-async';

const MissingMovieForm: React.FC = () => {
  const { user } = useAuth();

  return (
    <>
      <Helmet>
        <title>Suggest a Movie - Next in Cinema</title>
        <meta name="description" content="Suggest a missing movie to be added to Next in Cinema" />
      </Helmet>
      
      <div className="min-h-screen pt-20 bg-background-light">
        <div className="container-custom py-8">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-8">
              <h1 className="section-title">Suggest a Missing Movie</h1>
              <p className="text-secondary">
                Help us improve our database by suggesting movies that should be featured on Next in Cinema.
              </p>
            </div>
            
            <div className="card p-8">
              <form action="https://formspree.io/f/mgvklaeo" method="POST" className="space-y-6">
                <div>
                  <label htmlFor="email" className="block text-secondary-dark text-sm font-semibold mb-2">
                    Your Email:
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    defaultValue={user?.email || ''}
                    readOnly={!!user}
                    className={`w-full py-3 px-4 border border-secondary/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors duration-200 ${
                      user ? 'bg-background-light text-secondary' : 'bg-white text-secondary-dark'
                    }`}
                    placeholder={user ? '' : 'your.email@example.com'}
                  />
                  {user && (
                    <p className="text-sm text-secondary mt-1">
                      Using your account email
                    </p>
                  )}
                </div>

                <div>
                  <label htmlFor="movie" className="block text-secondary-dark text-sm font-semibold mb-2">
                    Missing Movie Title: <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="movie"
                    id="movie"
                    required
                    className="w-full py-3 px-4 border border-secondary/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors duration-200 bg-white text-secondary-dark"
                    placeholder="Enter the movie title"
                  />
                </div>

                <div>
                  <label htmlFor="imdb" className="block text-secondary-dark text-sm font-semibold mb-2">
                    IMDb Link (optional):
                  </label>
                  <input
                    type="url"
                    name="imdb"
                    id="imdb"
                    className="w-full py-3 px-4 border border-secondary/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors duration-200 bg-white text-secondary-dark"
                    placeholder="https://www.imdb.com/title/..."
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-secondary-dark text-sm font-semibold mb-2">
                    Additional Comments:
                  </label>
                  <textarea
                    name="message"
                    id="message"
                    rows={4}
                    className="w-full py-3 px-4 border border-secondary/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors duration-200 bg-white text-secondary-dark resize-vertical"
                    placeholder="Any additional information about the movie, release date, etc."
                  ></textarea>
                </div>

                <div className="flex justify-center pt-4">
                  <button
                    type="submit"
                    className="btn-primary px-8 py-3 text-lg"
                  >
                    Submit Suggestion
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MissingMovieForm;